// TODO Actualizar en relación a la lista de funciones de la base de datos
enum FunctionsEnum {
  ABMUserAdmin = 1, // View list of userss
  ABMUserAdd = 2, // en Function 1
  ABMUserEdit = 3, // en Function 1
  ABMUserDelete = 4, // en Function 1
  ABMUserActiveInactive = 5, // en Function 1
  Viewproject = 6, // en Function 1 (No desarrollado)
  AddProject = 7, // en Function 6 (No desarrollado)
  Projects = 8, // Project list
  ProjectDetail = 9, // en Function 8
  EditProject = 10, // en Function 8 - Documents by project Page
  DeleteProject = 11, // en Function 8
  AddDocument = 12, // en Function 10
  UploadXLSX = 13, // en Function 10
  DownloadXLSX = 14, // en Function 10
  EditDocument = 15, // en Function 10
  DeleteDocument = 16, // en Function 10
  SynchronizationList = 17, // en Function 8
  DelayedDocsPage = 18, // en Function 10 - Delayed Docs Pages
  AddJustification = 19, // en Function 18
  ApproveJustification = 20 // en Function 18
}

export default FunctionsEnum;
